import {DateTime} from 'luxon';

import {BIWEEK, QUARTER, WEEK} from '../util/intervals.js';

export default function formatter(mosaic) {
  const startDate = DateTime.fromISO(mosaic.first_acquired, {zone: 'utc'});
  const endDate = DateTime.fromISO(mosaic.last_acquired, {zone: 'utc'});

  let label = [
    'common:date.monthAndYear',
    {
      date: startDate,
    },
  ];
  if (mosaic.interval === QUARTER) {
    const finalDate = endDate.minus({months: 1});
    label = [
      'common:date_ranges.quarterRange',
      {
        startDate: startDate,
        endDate: finalDate,
      },
    ];
  } else if (mosaic.interval === WEEK || mosaic.interval === BIWEEK) {
    const finalDate = endDate.minus({days: 1});
    label = [
      'common:date_ranges.weeklyOrBiweeklyRange',
      {
        startDate: startDate,
        endDate: finalDate,
      },
    ];
  }
  return label;
}
